import React from 'react';
import HeaderPrint from "../HeaderPrint/HeaderPrint";
import TableRelations from "./TableRelations";

const Relationships = ({data}) => {

  try {
    return (
      <>
        {data?.data?.data.map((item, index) => (
          <React.Fragment key={index}>
            <section className="print__domains">
              <HeaderPrint
                englishTitle={"Relationships"}
                persianTitle={"رابطه ها"}
                color={"#FFDF00"}
              />
              <div className="table__domains__text iransans-b">
                <div className="table__domains__name">
                  <span>کاربـر</span>
                  <span>:</span>
                  <span>{item.user}</span>
                </div>
                <div className="table__domains__date">
                  <span>تاریخ</span>
                  <span>:</span>
                  <span>{item.date}</span>
                </div>
              </div>
              <div
                className="table__domains__box"
                style={{width: "100%"}}
              >
                <TableRelations tableItems={item.table}/>
              </div>
            </section>
            {index < data?.data?.data.length - 1 && (
              <div style={{pageBreakBefore: "always"}}></div>
            )}
          </React.Fragment>
        ))}
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default Relationships;